import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LeftBarSports from "../../../components/LeftBarSports";
import { AnvioGamesData } from "../../../../lib/data/AnvioGames.data";

const AnvioGames = () => {
  const categoriesTab = [{ name: "Anvio Games", key: "anvioGames" }];
  const [activeCategory, setActiveCategory] = useState("anvioGames");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  return (
    <>
      <main className="main">
        <div className="home-section">
          <div className="left-section">
            <LeftBarSports />
          </div>
          <div className="right-section">
            <div className="container-fluid">
              <div className="casinoProvidersGames">
                <ul className="tabs">
                  {categoriesTab.map((tab, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setFilteredData([]);
                        setIsSearched(false);
                        setSearchQuery("");
                        if (tab?.redirectUrl) {
                          navigate(tab?.redirectUrl);
                        } else {
                          setActiveCategory(tab.key);
                        }
                      }}
                      style={
                        activeCategory === tab.key
                          ? {
                              background: "#182838",
                            }
                          : {}
                      }
                    >
                      <a
                        href="#"
                        style={
                          activeCategory === tab.key
                            ? {
                                color: "#fff",
                              }
                            : {}
                        }
                      >
                        {tab.name}
                      </a>
                    </li>
                  ))}
                </ul>

                {!isSearched ? (
                  <ul className="games">
                    {Array.isArray(Object.values(AnvioGamesData)) &&
                      Object.values(AnvioGamesData)
                        .filter((f) => f?.key === activeCategory)
                        .map((slide) =>
                          Object.values(slide)
                            .filter((f) => typeof f !== "string")
                            .map((game) =>
                              Object.values(game).map((item, idx) => (
                                <li key={"casinogame" + idx}>
                                  <a
                                    className="play-button"
                                    href={item.redirectUrl}
                                  >
                                    <img src={item.imgUrl} alt={item.name} />
                                    <div className="play-btn">
                                      <img
                                        src="./images/play-btn.png"
                                        alt="play"
                                      />
                                    </div>
                                    <div className="name">{item.name}</div>
                                  </a>
                                </li>
                              ))
                            )
                        )}
                  </ul>
                ) : (
                  <ul className="games">
                    {filteredData.length > 0 &&
                      filteredData.map((game, idx) => (
                        <li key={"casinogame" + idx}>
                          <a className="play-button" href={game.redirectUrl}>
                            <img src={game.imgUrl} alt={game.name} />
                            <div className="play-btn">
                              <img src="./images/play-btn.png" alt="play" />
                            </div>
                            <div className="name">{game.name}</div>
                          </a>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AnvioGames;
